import { Component, Input, OnInit } from '@angular/core';
import { Person } from '../../../../models/person';
import { ChangeRequestService } from '../../../../services/change-request.service';
import {
  AddressChangeRequest,
  AERequestStatusType,
  ChangeRequestData,
  ChangeRequestHistoryEntry,
  DirectDepositRequest,
  RequestData
} from '../../../../models/change-requests';

@Component({
  selector: 'lib-employee-request-history',
  templateUrl: './employee-request-history.component.html',
  styleUrls: ['./employee-request-history.component.css'],
  standalone: false
})
export class EmployeeRequestHistoryComponent implements OnInit {
  @Input()
  public person: Person;

  @Input()
  public clientCode: string;

  addressRequestData: ChangeRequestData<AddressChangeRequest>;
  directDepositRequestData: ChangeRequestData<DirectDepositRequest>;
  selectedRequest: ChangeRequestHistoryEntry;

  public requests: ChangeRequestHistoryEntry[] = [];

  constructor(private service: ChangeRequestService) {}

  ngOnInit() {
    this.service.getRequestsRequester(this.clientCode, this.person.Id).subscribe(requests => {
      this.requests = requests;
    });
  }

  viewRequest(request: ChangeRequestHistoryEntry) {
    if (request.RequestType == 'Address Change') {
      this.service
        .getFinalizedAddressRequestData(this.clientCode, this.person.Id, request.Id)
        .subscribe(data => {
          this.addressRequestData = data;
          this.selectedRequest = request;
        });
    } else if (request.RequestType == 'Direct Deposit Change') {
      this.service
        .getFinalizedDirectDepositRequestData(this.clientCode, this.person.Id, request.Id)
        .subscribe(data => {
          this.directDepositRequestData = data;
          this.selectedRequest = request;
        });
    }
  }

  closeModal(
    result: {
      Operation: 'accept' | 'decline' | 'dismiss' | 'cancel';
      Result: boolean;
    } | null = null
  ) {
    if (result != null && result.Operation == 'cancel') {
      this.service.getRequestsRequester(this.clientCode, this.person.Id).subscribe(requests => {
        this.requests = requests;
        this.addressRequestData = null;
        this.directDepositRequestData = null;
        this.selectedRequest = null;
      });
    } else {
      this.addressRequestData = null;
      this.directDepositRequestData = null;
      this.selectedRequest = null;
    }
  }
}
